// extracted by mini-css-extract-plugin
module.exports = {"lang_selector_icon":"LanguageSelect_lang_selector_icon_3NiEv"};